import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { profileUrlFragment } from "@/components/account/utils"
import { ActivityFeedLiveTimestampFragment } from "@/components/activity-feed/ActivityFeedLiveTimestamp.fragment"
import { ActivityPriceFragment } from "@/components/activity-feed/ActivityPrice.fragment"
import { ItemAvatarFragment } from "@/components/items/avatar/ItemAvatar"

export const MintFeedTableRowFragment = graphql(
  `
    fragment MintFeedTableRow on Activity {
      id
      ... on Mint {
        quantity
        item {
          ...ItemAvatar
        }
        minter: to {
          ...AccountLockup
          ...profileUrl
        }
        collection {
          imageUrl
        }
        ...ActivityPrice
        ...ActivityFeedLiveTimestamp
      }
    }
  `,
  [
    ItemAvatarFragment,
    ActivityFeedLiveTimestampFragment,
    ActivityPriceFragment,
    AccountLockupFragment,
    profileUrlFragment,
  ],
)
